import React from 'react'
// libs
import { change } from 'redux-form'
import { useDispatch } from 'react-redux'
// types
import { Forms } from 'constants/forms'
import { IRiskFieldValue } from 'types/risk'
// context
import { RiskTransactionsContext } from 'containers/Risks/Risk/Edit/layers/RiskTransactions'
// hooks
import { useCurrentForm } from 'hooks/risks/useCurrentForm'

export const useFormValueUpdate = (name: string, fieldValue: IRiskFieldValue) => {
  const dispatch = useDispatch()

  const { fieldValueToUpdate, clearFieldValueToUpdate } = React.useContext(RiskTransactionsContext)

  const { fieldLink } = useCurrentForm()

  React.useEffect(() => {
    if (!fieldValueToUpdate) {
      return
    }

    const { fieldId, fieldLinkId, fieldValueId, parentFieldValueId } = fieldValueToUpdate

    if (
      fieldLinkId === fieldLink.id && fieldLink.primary
        ? fieldValueId === fieldValue.fieldValueId
        : fieldId === fieldLink.field.id && parentFieldValueId === fieldValue.parentFieldValueId
    ) {
      dispatch(
        change(Forms.RISK_TEMPLATE_FORM, name, {
          ...fieldValue,
          value: fieldValueToUpdate.fieldValue
        })
      )

      clearFieldValueToUpdate()
    }
  }, [fieldValueToUpdate])
}
